import { isIOS } from "@stepapp/core";
import React from "react";
import {
	Switch as RNSwitch,
	type StyleProp,
	StyleSheet,
	type ViewStyle,
} from "react-native";

import { palette, spacing } from "../styles";
import Block from "./Block";
import Typography from "./Typography";

type Props = {
	label: string;
	description?: string;
	value: boolean;
	onValueChange: (value: boolean) => void;
	style?: StyleProp<ViewStyle>;
};

const Switch = ({ label, description, value, style, onValueChange }: Props) => {
	return (
		<Block alignCenter justifySpace row marginVertical={1} style={style}>
			<Block style={styles.textContainer}>
				<Typography>{label}</Typography>
				{description && (
					<Typography numberOfLines={2} variant="lightLabel" type="secondary">
						{description}
					</Typography>
				)}
			</Block>

			<RNSwitch
				// @ts-expect-error RNW prop
				activeThumbColor={palette.primary.accent}
				onValueChange={onValueChange}
				thumbColor={isIOS ? palette.common.white : palette.primary.accent}
				trackColor={{
					true: isIOS ? palette.primary.accent : palette.primary.accentLight,
					false: isIOS ? palette.common.white : palette.font.placeholder,
				}}
				value={value}
				style={styles.switch}
			/>
		</Block>
	);
};

export default React.memo(Switch);

const styles = StyleSheet.create({
	switch: {
		marginLeft: spacing.unit,
	},
	textContainer: {
		flexShrink: 1,
	},
});
